import settingsRoutes from "./settings"

export default [
  ...settingsRoutes
]